export default {"src":"/_next/static/media/write_answer.7dd5f2bd.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};